import React, { useState, useContext } from "react";
import "./style.scss";
import { useNavigate, Link } from "react-router-dom";
import UserContext from "../../context/userContext";

const Login = () => {
  const { setStripeUser, setPremiumToken } = useContext(UserContext);
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    identifier: "",
    password: "",
  });
  const [error, setError] = useState(null);
  const [feedback, setFeedback] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("credentials", credentials);

    try {
      const response = await fetch(
        "https://www.calmestcrypto.com/stripe/login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(credentials),
        }
      );

      const data = await response.json();

      if (response.status !== 200) {
        throw new Error(data.message);
      }

      // Store token or take any necessary actions upon successful login
      // e.g., store the token in local storage, redirect the user to the dashboard, etc.
      localStorage.setItem("authToken", data.token); // assuming your backend sends a token upon successful login
      setPremiumToken(data.token);
    //   console.log("data", data);
      if (
        data === "No user found with provided identifier" ||
        data === "incorrect password"
      ) {
        // alert ('here');
        setFeedback("Invalid credentials.");
      }
      setStripeUser({ username: data.user.username });
      navigate("/premium");
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="login-container">
      <h2>Login</h2>
      {/* {error && <div className="error-message">{error}</div>} */}
      <form onSubmit={handleSubmit}>
        <label>
          Username or Email
          <input
            type="text"
            value={credentials.usernameOrEmail}
            onChange={(e) =>
              setCredentials({ ...credentials, identifier: e.target.value })
            }
          />
        </label>
        <label>
          Password
          <input
            type="password"
            value={credentials.password}
            onChange={(e) =>
              setCredentials({ ...credentials, password: e.target.value })
            }
          />
        </label>
        <span className="feedback">{feedback}</span>
        <button type="submit">Login</button>
      </form>
      <p>
        Don't have an account?&nbsp;
        <Link to="/register" className="register-link">
          Register now!
        </Link>
      </p>
      <p>
        <Link to="/password-reset" className="forgot-password-link">
          Forgot your password?
        </Link>
      </p>
    </div>
  );
};

export default Login;
